import areIntlLocalesSupported from 'intl-locales-supported';

let DateTimeFormat;

if(areIntlLocalesSupported(['ru'])) {
    DateTimeFormat = global.Intl.DateTimeFormat;
} else {
    const IntlPolyfill = require('intl');

    DateTimeFormat = IntlPolyfill.DateTimeFormat;
    require('intl/locale-data/jsonp/ru');
}

export default DateTimeFormat;



// WEBPACK FOOTER //
// ./src/blocks/date-picker/DateTimeFormat.js